import { render, staticRenderFns } from "./ValueComparison.vue?vue&type=template&id=7453b3d2&scoped=true"
import script from "./ValueComparison.vue?vue&type=script&lang=js"
export * from "./ValueComparison.vue?vue&type=script&lang=js"
import style0 from "./ValueComparison.vue?vue&type=style&index=0&id=7453b3d2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7453b3d2",
  null
  
)

export default component.exports